var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import isObject from "lodash/isObject";
import exhaust from "../utils/exhaust";
import getFinalType from "../utils/getFinalType";
var ModifiersParams;
(function (ModifiersParams) {
    ModifiersParams["connect"] = "connect";
    ModifiersParams["create"] = "create";
    ModifiersParams["createMany"] = "createMany";
    ModifiersParams["delete"] = "delete";
    ModifiersParams["deleteMany"] = "deleteMany";
    ModifiersParams["disconnect"] = "disconnect";
    ModifiersParams["set"] = "set";
    ModifiersParams["update"] = "update";
    ModifiersParams["updateMany"] = "updateMany";
    ModifiersParams["upsert"] = "upsert";
    ModifiersParams["connectOrCreate"] = "connectOrCreate";
})(ModifiersParams || (ModifiersParams = {}));
var getCreateInputDataTypeForList = function (createModifier, introspectionResults) {
    var createListModifierType = createModifier.type;
    var createInputFieldType = createListModifierType.ofType.kind === "NON_NULL"
        ? createListModifierType.ofType.ofType
        : createListModifierType.ofType;
    return introspectionResults.types.find(
    // what about a nullable type?
    function (t) { return t.name === createInputFieldType.name; });
};
var getUpdateInputDataTypeForList = function (updateModifier, introspectionResults) {
    var updateListModifierType = updateModifier.type;
    var updateInputFieldType = getFinalType(updateListModifierType.ofType);
    var updateListInputDataType = introspectionResults.types.find(function (introdspectionType) {
        return introdspectionType.name === updateInputFieldType.name;
    }).inputFields.find(function (input) { return input.name === "data"; })
        .type;
    var updateListInputDataName = (updateListInputDataType.kind === "NON_NULL"
        ? updateListInputDataType.ofType
        : updateListInputDataType).name;
    return introspectionResults.types.find(function (introdspectionType) { return introdspectionType.name === updateListInputDataName; });
};
function isObjectWithId(data) {
    return Boolean(data === null || data === void 0 ? void 0 : data.id);
}
var buildNewInputValue = function (fieldData, previousFieldData, fieldName, fieldType, introspectionResults) {
    var kind = fieldType.kind;
    switch (kind) {
        case "SCALAR":
        case "ENUM": {
            // if its a date, convert it to a date
            if (fieldType.kind === "SCALAR" && fieldType.name === "DateTime") {
                return new Date(fieldData);
            }
            if (fieldType.kind === "SCALAR" && fieldType.name === "String") {
                if (isObject(fieldData)) {
                    return JSON.stringify(fieldData);
                }
            }
            return fieldData;
        }
        case "INPUT_OBJECT": {
            var fieldObjectType_1 = fieldType;
            var fullFieldObjectType = introspectionResults.types.find(function (t) { return t.name === fieldObjectType_1.name; });
            var setModifier = fullFieldObjectType === null || fullFieldObjectType === void 0 ? void 0 : fullFieldObjectType.inputFields.find(function (i) { return i.name === ModifiersParams.set; });
            var connectModifier = fullFieldObjectType === null || fullFieldObjectType === void 0 ? void 0 : fullFieldObjectType.inputFields.find(function (i) { return i.name === ModifiersParams.connect; });
            var disconnectModifier = fullFieldObjectType === null || fullFieldObjectType === void 0 ? void 0 : fullFieldObjectType.inputFields.find(function (i) { return i.name === ModifiersParams.disconnect; });
            var deleteModifier = fullFieldObjectType === null || fullFieldObjectType === void 0 ? void 0 : fullFieldObjectType.inputFields.find(function (i) { return i.name === ModifiersParams.delete; });
            if (setModifier && !connectModifier && !disconnectModifier && !deleteModifier) {
                // if its a date, convert it to a date
                if (setModifier.type.kind === "SCALAR" &&
                    setModifier.type.name === "DateTime") {
                    return { set: new Date(fieldData) };
                }
                return { set: fieldData };
            }
            var isRelationship = fullFieldObjectType === null || fullFieldObjectType === void 0 ? void 0 : fullFieldObjectType.inputFields.every(function (i) {
                return Object.keys(ModifiersParams).includes(i.name);
            });
            // is it a relation?
            if (isRelationship) {
                // if it has a set modifier, it is an update array
                var createModifier = fullFieldObjectType === null || fullFieldObjectType === void 0 ? void 0 : fullFieldObjectType.inputFields.find(function (i) { return i.name === ModifiersParams.create; });
                var updateModifier = fullFieldObjectType === null || fullFieldObjectType === void 0 ? void 0 : fullFieldObjectType.inputFields.find(function (i) { return i.name === ModifiersParams.update; });
                var isList = fullFieldObjectType === null || fullFieldObjectType === void 0 ? void 0 : fullFieldObjectType.inputFields.some(function (i) {
                    return i.type.kind === "LIST";
                });
                if (isList) {
                    if (Array.isArray(fieldData)) {
                        var createListInputType_1 = getCreateInputDataTypeForList(createModifier, introspectionResults);
                        var updateListInputType_1 = updateModifier
                            ? getUpdateInputDataTypeForList(updateModifier, introspectionResults)
                            : null;
                        var variables = fieldData.reduce(function (inputs, referencedField) {
                            if (isObject(referencedField)) {
                                // TODO: we assume "data.id" to be the id
                                if (isObjectWithId(referencedField)) {
                                    var connectRelation = !(previousFieldData === null || previousFieldData === void 0 ? void 0 : previousFieldData.find(function (p) {
                                        return p.id
                                            ? p.id === referencedField.id
                                            : p === referencedField.id;
                                    }));
                                    if (!updateListInputType_1 || connectRelation) {
                                        inputs.connect = __spreadArray(__spreadArray([], (inputs.connect || []), true), [
                                            { id: referencedField.id },
                                        ], false);
                                    }
                                    else {
                                        // update
                                        var data = buildData(updateListInputType_1, {
                                            id: referencedField.id,
                                            data: referencedField,
                                            previousData: previousFieldData === null || previousFieldData === void 0 ? void 0 : previousFieldData.find(function (previousField) {
                                                // TODO: we assume ".id" to be the id
                                                return previousField.id === referencedField.id;
                                            }),
                                        }, introspectionResults);
                                        if (Object.keys(data).length) {
                                            inputs.update = __spreadArray(__spreadArray([], (inputs.update || []), true), [
                                                { where: { id: referencedField.id }, data: data },
                                            ], false);
                                        }
                                    }
                                }
                                else {
                                    // create
                                    var data = buildData(createListInputType_1, {
                                        data: referencedField,
                                    }, introspectionResults);
                                    inputs.create = __spreadArray(__spreadArray([], (inputs.create || []), true), [data], false);
                                }
                            }
                            else {
                                // only reference id's
                                // what about multiple id's for one reference?
                                if (!(previousFieldData === null || previousFieldData === void 0 ? void 0 : previousFieldData.find(function (p) {
                                    // TODO: we assume "p.id" to be the id
                                    return p.id
                                        ? p.id === referencedField
                                        : p === referencedField;
                                }))) {
                                    inputs.connect = __spreadArray(__spreadArray([], (inputs.connect || []), true), [
                                        { id: referencedField },
                                    ], false);
                                }
                            }
                            return inputs;
                        }, {});
                        // disconnect the ones that are not referenced anymore
                        if (Array.isArray(previousFieldData)) {
                            var removableRelations = previousFieldData.reduce(function (inputs, data) {
                                // TODO: we assume "data.id" to be the id
                                var dataId = data.id || data;
                                if (!fieldData.find(function (p) {
                                    // TODO: we assume "p.id" to be the id
                                    var pId = p.id || p;
                                    return pId === dataId;
                                })) {
                                    return __spreadArray(__spreadArray([], (inputs || []), true), [{ id: dataId }], false);
                                }
                                return inputs;
                            }, []);
                            if (removableRelations.length) {
                                if (disconnectModifier) {
                                    variables.disconnect = removableRelations;
                                }
                                else if (deleteModifier) {
                                    variables.delete = removableRelations;
                                }
                            }
                        }
                        return variables;
                    }
                    else {
                        throw new Error(fieldName + " should be an array");
                    }
                }
                else {
                    if (!fieldData) {
                        if (disconnectModifier) {
                            return {
                                disconnect: true,
                            };
                        }
                        else if (deleteModifier) {
                            return {
                                delete: true,
                            };
                        }
                    }
                    if (isObject(fieldData)) {
                        if (!isObjectWithId(fieldData)) {
                            if (!createModifier) {
                                return;
                            }
                            // TODO: we assume ".id" to be the id
                            var createObjectModifierType_1 = getFinalType(createModifier.type);
                            var createObjectInputType = introspectionResults.types.find(function (t) { return t.name === createObjectModifierType_1.name; });
                            // create
                            var data = buildData(createObjectInputType, {
                                data: fieldData,
                            }, introspectionResults);
                            return { create: data };
                        }
                        else {
                            if ((previousFieldData === null || previousFieldData === void 0 ? void 0 : previousFieldData.id) === fieldData.id) {
                                if (!updateModifier) {
                                    return;
                                }
                                var updateObjectModifierType_1 = getFinalType(updateModifier.type);
                                var updateObjectInputType = introspectionResults.types.find(function (t) { return t.name === updateObjectModifierType_1.name; });
                                // update
                                var data = buildData(updateObjectInputType, {
                                    id: fieldData.id,
                                    data: fieldData,
                                    previousData: previousFieldData,
                                }, introspectionResults);
                                return { update: data };
                            }
                            else if (connectModifier) {
                                return { connect: { id: fieldData.id } };
                            }
                        }
                    }
                    else if (connectModifier) {
                        return { connect: { id: fieldData } };
                    }
                }
            }
            else {
                return fieldData;
            }
            return;
        }
        case "LIST":
        case "NON_NULL":
            return;
        default:
            exhaust(kind);
    }
};
export var buildData = function (inputType, params, introspectionResults) {
    if (!inputType) {
        return {};
    }
    return inputType.inputFields.reduce(function (acc, field) {
        var _a;
        var _b, _c, _d;
        var key = field.name;
        var fieldType = field.type.kind === "NON_NULL" ? field.type.ofType : field.type;
        var fieldData = params.data[key];
        //console.log(key, fieldData, fieldType);
        var previousFieldData = (_d = (_c = (_b = params) === null || _b === void 0 ? void 0 : _b.previousData) === null || _c === void 0 ? void 0 : _c[key]) !== null && _d !== void 0 ? _d : null;
        // TODO in case the content of the array has changed but not the array itself?
        if (isEqual(fieldData, previousFieldData) ||
            (isNil(previousFieldData) && isNil(fieldData))) {
            return acc;
        }
        var newVaue = buildNewInputValue(params.data[key], previousFieldData, field.name, fieldType, introspectionResults);
        return __assign(__assign({}, acc), (_a = {}, _a[key] = newVaue, _a));
    }, {});
};
//# sourceMappingURL=buildData.js.map